import { Typography } from 'antd';

const dayjs = require('dayjs');

dayjs.locale('en');

const ANNUALLY = 'ANNUALLY';
const PREVIOUS_QUARTER = 'PREVIOUS_QUARTER';
const CHURN_YAXIS_LABEL = 'Transaction';
const DASHBOARD_SUMMARY_TEXT = {
  total_transaction_count: 'Transaction Count',
  total_transaction_amount: 'Gross Transaction Value',
  success_count: 'Success Count',
  success_rate: 'Success Rate (%)'
};
const COMMISSION_SUMMARY_TEXT = {
  total_success_amount: 'Success Amount',
  total_commission_amount: 'Commission Amount',
  total_success_count: 'Success Count',
  commission_percentage: 'Commission (%)'
};

const DASHBOARD_PAGE = 'partner-dashboard';
const BAR_COLOR = ['#042169', '#1B4FCB', '#517CE3', '#C7D7FD'];
const CHURN_XAXIS_LABEL = 10;
const RANGE_PRESETS_DAYS = [
  { label: 'Last 7 Days', value: [dayjs().add(-6, 'd'), dayjs()] },
  { label: 'Last 14 Days', value: [dayjs().add(-13, 'd'), dayjs()] },
  { label: 'Last 30 Days', value: [dayjs().add(-29, 'd'), dayjs()] }
];
const QUARTER = { 4: 'April-June', 7: 'July-Sept', 10: 'Oct-Dec', 1: 'Jan-Mar' };
const CHURN_MONTH_TAG = 'Last 3 Months';
const CHURN_QUARTER_TAG = 'Last 4 Quarters';
const MONTH_NAME = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const columnStyles = {
  fontWeight: 600,
  fontSize: '15px',
  textAlign: 'center',
  width: '100%',
  whiteSpace: 'nowrap'
};
const textStyle = {
  fontWeight: 200,
  fontSize: '14px',
  width: '100%'
};

const generateColumn = (title, dataIndex, key, render, align = 'center') => ({
  title: <Typography.Text style={columnStyles}>{title}</Typography.Text>,
  dataIndex,
  key,
  render,
  align
});
const generateColumnChurn = (title, dataIndex, key, width, render, align = 'center') => ({
  title: <Typography.Text style={columnStyles}>{title}</Typography.Text>,
  dataIndex,
  key,
  width,
  render,
  align
});
const PAYMENT_MODE_COLUMNS = [
  generateColumn('Payment mode', 'title', 'title', (mode) => (
    <Typography.Text style={textStyle}>{mode}</Typography.Text>
  )),
  generateColumn('Transaction Count', 'total_count', 'total_count', (count) => (
    <Typography.Text style={textStyle}>{count}</Typography.Text>
  )),
  generateColumn('Success Count', 'success_count', 'success_count', (count) => (
    <Typography.Text style={textStyle}>{count}</Typography.Text>
  )),
  generateColumn('Failure Count', 'failure_count', 'failure_count', (count) => (
    <Typography.Text style={textStyle}>{count}</Typography.Text>
  )),
  generateColumn('Other Count', 'drop_bounce_count', 'drop_bounce_count', (count) => (
    <Typography.Text style={textStyle}>{count}</Typography.Text>
  ))
];

const PAYMENT_MODE_COLUMNS_EXPORT = [
  'Payment mode',
  'Transaction Count',
  'Success Count',
  'Failure Count',
  'Other Count'
];

const getChurnColumn = (keyName) => {
  return [
    generateColumnChurn(
      'Merchant Name',
      'name',
      'name',
      '15px',
      (name) => (
        <Typography.Text style={{ ...textStyle, textAlign: 'left' }}>{name}</Typography.Text>
      ),
      'left'
    ),
    generateColumnChurn('Merchant ID', 'id', 'id', '10px', (id) => (
      <Typography.Text style={textStyle}>{id}</Typography.Text>
    )),
    ...keyName.map((key) =>
      generateColumnChurn(key, key, key, '10px', (count) => (
        <Typography style={textStyle}>{count}</Typography>
      ))
    ),
    generateColumnChurn(
      'Churn Magnitude',
      'churnMagnitude',
      'churnMagnitude',
      '10px',
      (magnitude) => <Typography style={textStyle}>{magnitude}</Typography>
    ),
    generateColumnChurn('Churn Rate', 'churnRate', 'churnRate', '10px', (rate) => (
      <Typography style={textStyle}>{rate}%</Typography>
    ))
  ];
};

const getChurnThreeMonthColumn = (keyName) => getChurnColumn(keyName);
const getChurnQuarterColumn = (keyName) => getChurnColumn(keyName);

export {
  DASHBOARD_SUMMARY_TEXT,
  RANGE_PRESETS_DAYS,
  PAYMENT_MODE_COLUMNS,
  ANNUALLY,
  PREVIOUS_QUARTER,
  CHURN_YAXIS_LABEL,
  MONTH_NAME,
  QUARTER,
  CHURN_XAXIS_LABEL,
  BAR_COLOR,
  CHURN_MONTH_TAG,
  DASHBOARD_PAGE,
  CHURN_QUARTER_TAG,
  COMMISSION_SUMMARY_TEXT,
  PAYMENT_MODE_COLUMNS_EXPORT,
  getChurnThreeMonthColumn,
  getChurnQuarterColumn
};
